<template>
  <div class="container flex min-h-screen flex-col">
    <div class="mb-3 py-3">
      <img src="/img/logo.svg" alt="logo oab diario" class="text-left" />
    </div>
    <div class="flex-1">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Layout404"
};
</script>

<style lang="scss" scoped>
img {
  width: 80px;
  // max-width: 80px;
  margin: 10px auto;
}
</style>
